// Generated from src/SueBiblio.js and public/pdf/*.pdf.
export const wikiTopics = [
  "Ape language research",
  "Chimpanzee studies",
  "Cognition, selfhood, and consciousness",
  "Evolution, culture, and morality",
  "Gesture, vocalization, and multimodal language",
  "Kanzi and bonobos",
  "Language comprehension",
  "Lexigrams and symbolic communication",
  "Tool use and material culture"
];

export const featuredWikiIds = [
  "1978-symbolic-communication-chimps",
  "1980-reference-linguistic-essential",
  "1986-spontaneous-symbol-acquisition",
  "1993-language-comprehension-ape",
  "1993-pan-tool-maker",
  "2019-pan-survival"
];

export const wikiEntries = [
  {
    "id": "1978-chimpanzee-language-research",
    "year": "1978",
    "title": "Chimpanzee language research: Status and potential",
    "citation": "Rumbaugh, D. M., Savage-Rumbaugh, E. S. (1978). Chimpanzee language research: Status and potential. Behavior Research Methods & Instrumentation, 10(2), 119-131.",
    "href": "/pdf/1978-Chimpanzee-Language-Research.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Chimpanzee studies",
      "Evolution, culture, and morality"
    ],
    "summary": "DUANE M. RUMBAUGH and SUE SAVAGE-RUMBAUGH Georgia State University, Atlanta, Georgia30303 and Yerkes Regional Primate Research Center, Emory University, A tlanta, Georgia 30322 The research herein reported was supported by Grants NICHD-06016 and RR .. 00165 from the National Institutes of Health."
  },
  {
    "id": "1978-symbolic-communication-chimps",
    "year": "1978",
    "title": "Symbolic communication between two chimpanzees (Pan troglodytes)",
    "citation": "Savage-Rumbaugh, E. S., Rumbaugh, D. M., & Boysen, S. (1978). Symbolic communication between two chimpanzees (Pan troglodytes). Science, 201(4356), 641-644. Doi",
    "href": "/pdf/1978-Symbolic-Communication-Chimps.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Chimpanzee studies",
      "Tool use and material culture"
    ],
    "summary": "Through use of learned symbols, two chimpanzees accurately specified 11 foods by name to one another when"
  },
  {
    "id": "1979-chimpanzee-problem-comprehension",
    "year": "1979",
    "title": "Chimpanzee Problem Comprehension: Insufficient Evidence",
    "citation": "Savage-Rumbaugh, E. S., Rumbaugh, D. M., Premack, D., & Woodruff, G. (1979). Chimpanzee Problem Comprehension: Insufficient Evidence . Science, 206(4423), 1201-1202. Ebsco",
    "href": "/pdf/1979-Chimpanzee-Problem-Comprehension.pdf",
    "topics": [
      "Language comprehension",
      "Chimpanzee studies"
    ],
    "summary": "This publication is part of the BHI research archive on language comprehension, chimpanzee studies. It is included because it documents a specific strand of ape language research connected to the bibliography: Chimpanzee Problem Comprehension: Insufficient Evidence. Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "1980-do-apes-use-language",
    "year": "1980",
    "title": "Do Apes Use Language? One research group considers the evidence for representational ability in apes",
    "citation": "Savage-Rumbaugh, E. S., Rumbaugh, D. M., & Boysen, S. (1980). Do Apes Use Language? One research group considers the evidence for representational ability in apes. American Scientist,68(1), 49-61. Spanish translation {\" \"} / Ebsco",
    "href": "/pdf/1980-Do-Apes-Use-Language.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Chimpanzee studies",
      "Tool use and material culture"
    ],
    "summary": "Author(s): E. Sue Savage-Rumbaugh, Duane M. Rumbaugh and Sarah Boysen Source: American Scientist , January-February 1980, Vol."
  },
  {
    "id": "1980-reference-linguistic-essential",
    "year": "1980",
    "title": "Reference: The Linguistic Essential",
    "citation": "Savage-Rumbaugh, E. S., Rumbaugh, D. M., Smith, S. T., & Lawson, J. (1980). Reference: The Linguistic Essential. Science, 210(4472), 922-925. Ebsco",
    "href": "/pdf/1980-Reference-Linguistic-Essential.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Tool use and material culture"
    ],
    "summary": "This publication is part of the BHI research archive on lexigrams and symbolic communication, tool use and material culture. It is included because it documents a specific strand of ape language research connected to the bibliography: Reference: The Linguistic Essential. Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "1981-variations-subsistence-activities",
    "year": "1981",
    "title": "Variations in Subsistence Activities of Female and Male Pongids: New Perspectives on the Origins of Hominid Labor Division [and Comments]",
    "citation": "Teleki, G., Coelho, A. M., Eckhardt, R. B., Fleagle, J. G., Hladik, C. M., Kelso, A. J., McGrew, W. C., Nash, L. T., Nishida, T., Paterson, J. D., Savage-Rumbaugh, S., Smith, E. O., Sugiyama, Y., & Wrangham, R. W. (1981). Variations in Subsistence Activities of Female and Male Pongids: New Perspectives on the Origins of Hominid Labor Division [and Comments]. Current Anthropology, 22(3), 241-256. Ebsco",
    "href": "/pdf/1981-Variations-Subsistence-Activities.pdf",
    "topics": [
      "Tool use and material culture"
    ],
    "summary": "This publication is part of the BHI research archive on tool use and material culture. It is included because it documents a specific strand of ape language research connected to the bibliography: Variations in Subsistence Activities of Female and Male Pongids: New Perspectives on the Origins of Hominid Labor Division [and Comments]. Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "1982-alr-alive-and-well",
    "year": "1982",
    "title": "Ape Language Research Is Alive and Well: A Reply",
    "citation": "Savage-Rumbaugh, E. S., & Rumbaugh, D. M. (1982). Ape Language Research Is Alive and Well: A Reply. Anthropos, 77(3/4), 568-573. Ebsco",
    "href": "/pdf/1982-ALR-Alive-and-Well.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Tool use and material culture"
    ],
    "summary": "Author(s): E. Sue Savage-Rumbaugh and Duane M. Rumbaugh Source: Anthropos , 1982, Bd."
  },
  {
    "id": "1984-review-primate-communication-essr",
    "year": "1984",
    "title": "Primate Communication",
    "citation": "Savage-Rumbaugh, S. (1984). Primate Communication (review of book by Charles T. Snowdon Charles H. Brown Michael & R. Petersen). In American Scientist, 72 286-288. Ebsco",
    "href": "/pdf/1984-Review-Primate-Communication-ESSR.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Tool use and material culture"
    ],
    "summary": "This publication is part of the BHI research archive on lexigrams and symbolic communication, tool use and material culture. It is included because it documents a specific strand of ape language research connected to the bibliography: Primate Communication. Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "1984-verbal-behavior-procedural",
    "year": "1984",
    "title": "Verbal behavior at a procedural level in the chimpanzee",
    "citation": "Savage-Rumbaugh, E. S. (1984). Verbal behavior at a procedural level in the chimpanzee. Journal of the Experimental Analysis of Behavior, 41(2), 223-250. Doi",
    "href": "/pdf/1984-Verbal-Behavior-Procedural.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Chimpanzee studies",
      "Cognition, selfhood, and consciousness"
    ],
    "summary": "This publication is part of the BHI research archive on lexigrams and symbolic communication, language comprehension. It is included because it documents a specific strand of ape language research connected to the bibliography: Verbal behavior at a procedural level in the chimpanzee. Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "1985-social-technological-model",
    "year": "1985",
    "title": "A Social-Technological Model for the Evolution of Language [and Comments and Reply]",
    "citation": "Parker, S. T., Allik, J., Help, T., Armstrong, D. F., Bloom, A. H., Dorais, L.-J., Hewes, G. W., Lieberman, P., Lock, A., Maratsos, M., Mounin, G., Mühlhäusler, P., Rolfe, L. H., Rumbaugh, D. M., Savage-Rumbaugh, E. S., Rumsey, A., Sinha, C. G., & Shunchiu, Y.(1985). A Social-Technological Model for the Evolution of Language [and Comments and Reply]. Current Anthropology, 26(5), 617-639. Ebsco",
    "href": "/pdf/1985-Social-Technological-Model.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Chimpanzee studies",
      "Tool use and material culture"
    ],
    "summary": "Author(s): Sue Taylor Parker, Jüri Allik, Toomas Help, David F. Armstrong, Alfred H. Bloom, Louis-Jacques Dorais, Gordon W."
  },
  {
    "id": "1985-capacity-to-acquire",
    "year": "1985",
    "title": "The Capacity of Animals to Acquire Language: Do Species Differences have Anything to Say to Us?",
    "citation": "Savage-Rumbaugh, E. S., Sevcik, R. A., Rumbaugh, D. M., & Rubert, E. (1985). The Capacity of Animals to Acquire Language: Do Species Differences have Anything to Say to Us? Philosophical Transactions of the Royal Society of London. Series B, Biological Sciences,308 (1135), 177-185. Ebsco",
    "href": "/pdf/1985-Capacity-To-Acquire.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Kanzi and bonobos",
      "Chimpanzee studies"
    ],
    "summary": "; (iv) very large species differences with regard to communicative capacities exist between even"
  },
  {
    "id": "1986-spontaneous-symbol-acquisition",
    "year": "1986",
    "title": "Spontaneous symbol acquisition and communicative use by pygmy chimpanzees (Pan paniscus)",
    "citation": "Savage-Rumbaugh, S., McDonald, K., Sevcik, R. A., Hopkins, W. D., & Rubert, E. (1986). Spontaneous symbol acquisition and communicative use by pygmy chimpanzees (Pan paniscus). Journal of Experimental Psychology: General, 115(3), 211-235. Doi",
    "href": "/pdf/1986-Spontaneous-Symbol-Acquisition.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Kanzi and bonobos",
      "Chimpanzee studies"
    ],
    "summary": "Sue Savage-Rumbaugh Department of Biology, Georgia State University Yerkes Regional Primate Research Center, Emory University Kelly Mc Donald, Rose A. Sevcik, and William D. Hopkins Language Research Center, Georgia State University Elizabeth Rubert Yerkes Regional Primate Research Center, Emory University Two pygmy champanzees (Pan paniscus) have spontaneously begun to use symbols to communicate with people."
  },
  {
    "id": "1987-symbolic-communication-language",
    "year": "1987",
    "title": "Communication, symbolic communication, and language: Reply to Seidenberg and Pettito",
    "citation": "Savage-Rumbaugh, E. S. (1987). Communication, symbolic communication, and language: Reply to Seidenberg and Pettito. Journal of Experimental Psychology: General, 116(3), 288-292. Doi",
    "href": "/pdf/1987-Symbolic-Communication-Language.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Kanzi and bonobos",
      "Chimpanzee studies"
    ],
    "summary": "Sue Savage-Rumbaugh Department of Biology, Georgia State University Yerkes Regional Primate Research Center, Emory University Seidenberg and Petitto's (1987) assertion that Kanzi and Mulika's lexigram usage is not representa- tional is evaluated by contrasting their abilities with Nim's. Kanzi and Mulika's data indicate that they (a) comprehend spoken English words; (b) can identify lexigram symbols when they hear these words; (c) can comprehend lexigram usage; (d) can use lexigrams when referents are absent and can, if asked, lead someone to the referent; and (e) that all these skills were acquired through..."
  },
  {
    "id": "1987-summation-in-chimpanzee",
    "year": "1987",
    "title": "Summation in the chimpanzee (Pan troglodytes)",
    "citation": "Rumbaugh, D. M., Savage-Rumbaugh, S., & Hegel, M. T. (1987). Summation in the chimpanzee (Pan troglodytes). Journal of Experimental Psychology: Animal Learning and Cognition , 13(2), 107-115.{\" \"} Pubmed",
    "href": "/pdf/1987-Summation-in-Chimpanzee.pdf",
    "topics": [
      "Language comprehension",
      "Chimpanzee studies",
      "Cognition, selfhood, and consciousness"
    ],
    "summary": "This publication is part of the BHI research archive on language comprehension, chimpanzee studies. It is included because it documents a specific strand of ape language research connected to the bibliography: Summation in the chimpanzee (Pan troglodytes). Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "1988-addendum-to-summation",
    "year": "1988",
    "title": "Addendum to 'Summation in the chimpanzee (Pan troglodytes).'",
    "citation": "Rumbaugh, D. M., Savage-Rumbaugh, E. S., & Pate, J. L. (1988). Addendum to 'Summation in the chimpanzee (Pan troglodytes).' Journal of Experimental Psychology: Animal Learning and Cognition, 14 (1), 118-120. Doi",
    "href": "/pdf/1988-Addendum-to-Summation.pdf",
    "topics": [
      "Language comprehension",
      "Chimpanzee studies",
      "Cognition, selfhood, and consciousness"
    ],
    "summary": "This publication is part of the BHI research archive on language comprehension, chimpanzee studies. It is included because it documents a specific strand of ape language research connected to the bibliography: Addendum to 'Summation in the chimpanzee (Pan troglodytes).'. Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "1988-symbolic-cross-modal-transfer",
    "year": "1988",
    "title": "Symbolic Cross-Modal Transfer in Two Species of Chimpanzees",
    "citation": "Savage-Rumbaugh, S., Sevcik, R. A., & Hopkins, W. D. (1988). Symbolic Cross-Modal Transfer in Two Species of Chimpanzees. Child Development, 59(3), 617-625. Doi",
    "href": "/pdf/1988-Symbolic-Cross-Modal-Transfer.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Kanzi and bonobos",
      "Chimpanzee studies"
    ],
    "summary": "Author(s): Sue Savage-Rumbaugh, Rose A. Sevcik and William D. Hopkins Source: Child Development , Jun., 1988, Vol."
  },
  {
    "id": "1989-mother-infant-conflict",
    "year": "1989",
    "title": "Mother-infant Conflict; Distal or proximate causes. Comments on Plooij and van de Rijt-Plooij's paper",
    "citation": "Savage-Rumbaugh, S. (1989). Mother-infant Conflict; Distal or proximate causes. Comments on Plooij and van de Rijt-Plooij's paper. European Journal of Psychology of Education, 4(2), 193-194. Ebsco",
    "href": "/pdf/1989-Mother-Infant-Conflict.pdf",
    "topics": [
      "Language comprehension",
      "Evolution, culture, and morality"
    ],
    "summary": "Sue Savage-Rumbaugh Georgia State University, Atlanta, USA. Noting the title of the paper by Plooij and van de Rijt-Plooij, one expects the evolution of human parental behavior to be the central focus of the work. However, for the reader who recognizes that the significant differences between human and ape parenting are in the areas of pedagogy, male participation, and the absence of infant clinging, the title will seem misleading as these topics are not discussed."
  },
  {
    "id": "1990-nasa-computerized-test",
    "year": "1990",
    "title": "The NASA/LRC Computerized Test System",
    "citation": "Richardson, W. K., Washburn, D. A., Hopkins, W. D., Savage-Rumbaugh, E. S., & Rumbaugh, D. M. (1990). The NASA/LRC Computerized Test System. Behavior Research Methods, Instruments, & Computers, 22(2), 127-131. Doi",
    "href": "/pdf/1990-NASA-Computerized-Test.pdf",
    "topics": [
      "Cognition, selfhood, and consciousness"
    ],
    "summary": "This publication is part of the BHI research archive on cognition, selfhood, and consciousness. It is included because it documents a specific strand of ape language research connected to the bibliography: The NASA/LRC Computerized Test System. Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "1991-early-postural-behavior-pan",
    "year": "1991",
    "title": "Early postural behavior in Pan: Influences on Development",
    "citation": "Brakke, K.E., & Savage-Rumbaugh, E.S. (1991). Early postural behavior in Pan: Influences on Development. Infant Behavior and Development, 14, 265-288.",
    "href": "/pdf/1991-Early-postural-behavior-Pan.pdf",
    "topics": [
      "Language comprehension",
      "Kanzi and bonobos",
      "Chimpanzee studies"
    ],
    "summary": "This publication is part of the BHI research archive on language comprehension, kanzi and bonobos. It is included because it documents a specific strand of ape language research connected to the bibliography: Early postural behavior in Pan: Influences on Development. Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "1991-evidence-asymmetrical-priming",
    "year": "1991",
    "title": "Evidence for asymmetrical hemispheric priming using known and unknown warning stimuli in two language-trained chimpanzees ( Pan troglodytes)",
    "citation": "Hopkins, W. D., Morris, R. D., & Savage-Rumbaugh, E. S. (1991). Evidence for asymmetrical hemispheric priming using known and unknown warning stimuli in two language-trained chimpanzees ( Pan troglodytes). Journal of Experimental Psychology: General, 120(1), 46-56.{\" \"} Doi",
    "href": "/pdf/1991-Evidence-Asymmetrical-Priming.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Chimpanzee studies",
      "Gesture, vocalization, and multimodal language"
    ],
    "summary": "This publication is part of the BHI research archive on lexigrams and symbolic communication, language comprehension. It is included because it documents a specific strand of ape language research connected to the bibliography: Evidence for asymmetrical hemispheric priming using known and unknown warning stimuli in two language-trained chimpanzees ( Pan troglodytes). Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "1991-multi-tasking-pan-human-rubicon",
    "year": "1991",
    "title": "Multi-tasking and the Pan-human Rubicon",
    "citation": "Savage-Rumbaugh, S. (1991). Multi-tasking and the Pan-human Rubicon. Seminars in the Neurosciences, 3, 417-422.",
    "href": "/pdf/1991-Multi-tasking-Pan-human-Rubicon.pdf",
    "topics": [
      "Ape language research"
    ],
    "summary": "This publication is part of the BHI research archive on ape language research. It is included because it documents a specific strand of ape language research connected to the bibliography: Multi-tasking and the Pan-human Rubicon. Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "1991-vocal-communication-rearing",
    "year": "1991",
    "title": "Vocal communication as a function of differential rearing experiences in{\" \"} Pan paniscus: A preliminary report",
    "citation": "Hopkins, W. D., & Savage-Rumbaugh, E.S. (1991). Vocal communication as a function of differential rearing experiences in{\" \"} Pan paniscus: A preliminary report. International Journal of Primatology, 12 (6), 559-583.",
    "href": "/pdf/1991-Vocal-Communication-Rearing.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Kanzi and bonobos",
      "Gesture, vocalization, and multimodal language"
    ],
    "summary": "iam D. Hopkins 1,2 and E. Sue Savage-Rumbaugh 2-4 Received August 9, 1990; accepted March 14, 1991 There is little evidence of vocal learning in nonhuman primates despite the well-documented abilities found in avian species."
  },
  {
    "id": "1992-hemispheric-priming-meaningful",
    "year": "1992",
    "title": "Hemispheric priming by meaningful and nonmeaningful symbols in language-trained chimpanzees (Pan troglodytes): further evidence of a left hemisphere advantage",
    "citation": "Hopkins, W. D., Morris, R. D., Savage-Rumbaugh, E. S., & Rumbaugh, D. M. (1992). Hemispheric priming by meaningful and nonmeaningful symbols in language-trained chimpanzees (Pan troglodytes): further evidence of a left hemisphere advantage. Behavioral Neuroscience, 106(3), 575-582. Doi",
    "href": "/pdf/1992-Hemispheric-Priming-Meaningful.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Chimpanzee studies"
    ],
    "summary": "This publication is part of the BHI research archive on lexigrams and symbolic communication, language comprehension. It is included because it documents a specific strand of ape language research connected to the bibliography: Hemispheric priming by meaningful and nonmeaningful symbols in language-trained chimpanzees (Pan troglodytes): further evidence of a left hemisphere advantage. Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "1993-imitative-learning-actions",
    "year": "1993",
    "title": "Imitative Learning of Actions on Objects by Children, Chimpanzees, and Enculturated Chimpanzees",
    "citation": "Tomasello, M., Savage-Rumbaugh, S., & Kruger, A. C. (1993). Imitative Learning of Actions on Objects by Children, Chimpanzees, and Enculturated Chimpanzees. Child Development, 64(6), 1688-1705. Doi",
    "href": "/pdf/1993-Imitative-Learning-Actions.pdf",
    "topics": [
      "Chimpanzee studies"
    ],
    "summary": "Article in Child Development · January 1994 DOI: 10.1111/j.1467-8624.1993.tb04207.x · Source: Pub Med CITATIONS 243 READS 333 3 authors, including: Ann Kruger Georgia State University 27 PUBLICATIONS 1,925 CITATIONS SEE PROFILE All content following this page was uploaded by Ann Kruger on 13 June 2014. The user has requested enhancement of the downloaded file. Imitativ e Learnin g o f Action s o n Object s by Children , Chimpanzees , an d Enculturate d Chimpanzee s Michael Tomasell o Emory University Sue Savage-Rumbaugh and Ann Cale Kruger Georgia State University TOMASELLO, MICHAEL ; SAVAGE-RUMBAUGH, SUE ;..."
  },
  {
    "id": "1993-language-comprehension-ape",
    "year": "1993",
    "title": "Language Comprehension in Ape and Child",
    "citation": "Savage-Rumbaugh, E. S., Murphy, J., Sevcik, R. A., Brakke, K. E., Williams, S. L., Rumbaugh, D. M., & Bates, E. (1993). Language Comprehension in Ape and Child. Monographs of the Society for Research in Child Development, 58 (3/4), i-252. Doi",
    "href": "/pdf/1993-Language-Comprehension-Ape.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Kanzi and bonobos",
      "Tool use and material culture"
    ],
    "summary": "This publication is part of the BHI research archive on lexigrams and symbolic communication, language comprehension. It is included because it documents a specific strand of ape language research connected to the bibliography: Language Comprehension in Ape and Child. Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "1993-pan-tool-maker",
    "year": "1993",
    "title": "Pan the Tool-Maker: Investigations into the Stone Tool-Making and Tool-Using Capabilities of a Bonobo (Pan paniscus)",
    "citation": "Toth, N., Schick, K. D., Savage-Rumbaugh, E. S., & Sevcik, R. A.(1993). Pan the Tool-Maker: Investigations into the Stone Tool-Making and Tool-Using Capabilities of a Bonobo (Pan paniscus). Journal of Archaeological Science, Great Britain.",
    "href": "/pdf/1993-Pan-Tool-Maker.pdf",
    "topics": [
      "Kanzi and bonobos",
      "Tool use and material culture"
    ],
    "summary": "This publication is part of the BHI research archive on kanzi and bonobos, tool use and material culture. It is included because it documents a specific strand of ape language research connected to the bibliography: Pan the Tool-Maker: Investigations into the Stone Tool-Making and Tool-Using Capabilities of a Bonobo (Pan paniscus). Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "1995-performance-tool-using-task",
    "year": "1995",
    "title": "Performance in a tool-using task by common chimpanzees ( Pan troglodytes), bonobos (Pan paniscus), an orangutan ( Pongo pygmaeus), and capuchin monkeys (Cebus apella)",
    "citation": "Visalberghi, E., Fragaszy, D. M., & Savage-Rumbaugh, S. (1995). Performance in a tool-using task by common chimpanzees ( Pan troglodytes), bonobos (Pan paniscus), an orangutan ( Pongo pygmaeus), and capuchin monkeys (Cebus apella). Journal of Comparative Psychology, 109(1), 52-60. Doi",
    "href": "/pdf/1995-Performance-Tool-Using-Task.pdf",
    "topics": [
      "Language comprehension",
      "Kanzi and bonobos",
      "Chimpanzee studies",
      "Tool use and material culture"
    ],
    "summary": "lisabetta Visalberghi Consiglio Nazionale delle Ricerche Dorothy M. Fragaszy University of Georgia Sue Savage-Rumbaugh Georgia State University Performance by individual animals of three species of great apes (Pan troglodytes, Pan paniscus, and Pongo pygmaeus) and capuchin monkeys (Cebus apella) was assessed by presenting a food treat inside a clear tube. The subjects readily used a straight stick to obtain the food."
  },
  {
    "id": "1995-development-language-skills-i",
    "year": "1995",
    "title": "The Development of Language Skills in Bonobo and Chimpanzee--I. Comprehension",
    "citation": "Brakke, K. E., & Savage-Rumbaugh, E. S. (1995). The Development of Language Skills in Bonobo and Chimpanzee--I. Comprehension. Language & Communication, 15, 121-148. Ebsco",
    "href": "/pdf/1995-Development-Language-Skills-I.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Kanzi and bonobos",
      "Chimpanzee studies"
    ],
    "summary": "KAREN E. BRAKKE and E. SUE SAVAGE-RUMBAUGH The species most closely related to our own are the bonobo (Pan paniscus) and the chimpanzee (Pan troglodytes), who diverged from the hominid evolutionary path as little as five to eight million years ago (Diamond, 1988; Miyamoto et a L, 1988)."
  },
  {
    "id": "1996-dev-language-skill-ii",
    "year": "1996",
    "title": "The development of language skills in PAN - II. Production",
    "citation": "Brakke, K. E., & Savage-Rumbaugh, E. S. (1996). The development of language skills in PAN - II. Production. Language & Communication, 16(4), 361-380. Ebsco",
    "href": "/pdf/1996-Dev-Language-Skill-II.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Tool use and material culture",
      "Gesture, vocalization, and multimodal language"
    ],
    "summary": "KAREN E. BRAKKE and E. SUE SAVAGE-RUMBAUGH Introduction We humans have long held great stock in our ability to use language to communicate with one another."
  },
  {
    "id": "1997-comprehension-skills-language",
    "year": "1997",
    "title": "Comprehension skills of language-competent and nonlanguage-competent apes",
    "citation": "Williams, S. L., Brakke, K. E., & Savage-Rumbaugh, E. S. (1997). Comprehension skills of language-competent and nonlanguage-competent apes. Language & Communication, 17(4), 301-318. Ebsco",
    "href": "/pdf/1997-Comprehension-Skills-Language.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Kanzi and bonobos",
      "Chimpanzee studies"
    ],
    "summary": "This publication is part of the BHI research archive on lexigrams and symbolic communication, language comprehension. It is included because it documents a specific strand of ape language research connected to the bibliography: Comprehension skills of language-competent and nonlanguage-competent apes. Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "1998-beyond-speciesism",
    "year": "1998",
    "title": "Beyond Speciesism",
    "citation": "Savage-Rumbaugh, S., Shanker, S. G., & Taylor, T. J. (1998). Beyond Speciesism. Apes, Language, and the Human Mind (pp. 181-228). Oxford University Press. ScholarWorks",
    "href": "/pdf/1998-Beyond-Speciesism.pdf",
    "topics": [
      "Language comprehension",
      "Kanzi and bonobos",
      "Cognition, selfhood, and consciousness",
      "Evolution, culture, and morality"
    ],
    "summary": "relationships between dissonant categories of things; of acquiring basic mathematical skills; and of learning other languages. Through such intercourse we could assure ourselves that technologically primi- tive man could come to live in, and possibly even adapt to,"
  },
  {
    "id": "1998-chimpanzee-counting",
    "year": "1998",
    "title": "Chimpanzee (Pan troglodytes) Counting in a Computerized Testing Paradigm",
    "citation": "Beran, M. J., Rumbaugh, D. M., & Savage-Rumbaugh, E. S. (1998). Chimpanzee (Pan troglodytes) Counting in a Computerized Testing Paradigm. The Psychological Record, 48(1), 3-20. Ebsco",
    "href": "/pdf/1998-Chimpanzee-Counting.pdf",
    "topics": [
      "Language comprehension",
      "Chimpanzee studies"
    ],
    "summary": "This publication is part of the BHI research archive on language comprehension, chimpanzee studies. It is included because it documents a specific strand of ape language research connected to the bibliography: Chimpanzee (Pan troglodytes) Counting in a Computerized Testing Paradigm. Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "1999-investigations-stone-tool",
    "year": "1999",
    "title": "Continuing Investigations into the Stone Tool-making and Tool-using Capabilities of a Bonobo (Pan paniscus)",
    "citation": "Schick, K. D., Toth, N., Garufi, G., Savage-Rumbaugh, E. S., Rumbaugh, D., & Sevcik, R. (1999). Continuing Investigations into the Stone Tool-making and Tool-using Capabilities of a Bonobo (Pan paniscus). Journal of Archeological Science, 26(7), 821-832. Ebsco",
    "href": "/pdf/1999-Investigations-Stone-Tool.pdf",
    "topics": [
      "Kanzi and bonobos",
      "Tool use and material culture"
    ],
    "summary": "This publication is part of the BHI research archive on kanzi and bonobos, tool use and material culture. It is included because it documents a specific strand of ape language research connected to the bibliography: Continuing Investigations into the Stone Tool-making and Tool-using Capabilities of a Bonobo (Pan paniscus). Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "1999-delay-gratification-chimpanzees",
    "year": "1999",
    "title": "Delay of gratification in chimpanzees (Pan troglodytes)",
    "citation": "Beran, M. J., Savage-Rumbaugh, E. S., Pate, J. L., & Rumbaugh, D. M. (1999). Delay of gratification in chimpanzees (Pan troglodytes). Dev Psychobiol, 34(2), 119-127. 3.0.co;2-p\" > Doi",
    "href": "/pdf/1999-Delay-Gratification-Chimpanzees.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Chimpanzee studies"
    ],
    "summary": ": Delay of grati®cation in 3 chimpanzees(Pan troglodytes) was examined by using a paradigm based on research with children."
  },
  {
    "id": "1999-kanzi-new-beginning",
    "year": "1999",
    "title": "Kanzi: A New Beginning",
    "citation": "Shanker, S. G., Savage-Rumbaugh, E. S., & Taylor, T. J. (1999). Kanzi: A New Beginning. Animal Learning and Behavior, 27(1), 24-25. Ebsco",
    "href": "/pdf/1999-Kanzi-New-Beginning.pdf",
    "topics": [
      "Language comprehension",
      "Kanzi and bonobos",
      "Tool use and material culture",
      "Cognition, selfhood, and consciousness"
    ],
    "summary": "rules operating on grammatical categories but rather by very specific compensatory strategies, including memoriza­ tion of inflected forms as unanalyzed lexical items and"
  },
  {
    "id": "1999-spontaneous-logicomathematical",
    "year": "1999",
    "title": "Spontaneous logicomathematical constructions by chimpanzees ( Pan troglodytes, Pan paniscus)",
    "citation": "Potì, P., Langer, J., Savage-Rumbaugh, S., & Brakke, K.E. (1999). Spontaneous logicomathematical constructions by chimpanzees ( Pan troglodytes, Pan paniscus). Animal Cognition, 2, 147–156.",
    "href": "/pdf/1999-Spontaneous-Logicomathematical.pdf",
    "topics": [
      "Language comprehension",
      "Kanzi and bonobos",
      "Chimpanzee studies",
      "Cognition, selfhood, and consciousness"
    ],
    "summary": "This publication is part of the BHI research archive on language comprehension, kanzi and bonobos. It is included because it documents a specific strand of ape language research connected to the bibliography: Spontaneous logicomathematical constructions by chimpanzees ( Pan troglodytes, Pan paniscus). Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "2000-ape-human-consciousness",
    "year": "2000",
    "title": "Ape Consciousness-Human Consciousness: A Perspective Informed by Language and Culture",
    "citation": "Savage-Rumbaugh, S. (2000). Ape Consciousness-Human Consciousness: A Perspective Informed by Language and Culture. American Zoologist, 40(6), 910-921. Ebsco",
    "href": "/pdf/2000-Ape-Human-Consciousness.pdf",
    "topics": [
      "Language comprehension",
      "Kanzi and bonobos",
      "Chimpanzee studies",
      "Cognition, selfhood, and consciousness"
    ],
    "summary": "code and with mutual understanding and coop- eration, was possible between non-human creatures (See Fig. 1). It also revealed that"
  },
  {
    "id": "2000-linguistic-cultural-cognitive-capacities",
    "year": "2000",
    "title": "Linguistic, Cultural and Cognitive Capacities of Bonobos ( Pan paniscus)",
    "citation": "Savage-Rumbaugh, E. S., & Fields, W. M. (2000). Linguistic, Cultural and Cognitive Capacities of Bonobos ( Pan paniscus). Culture and Psychology, 6(2), 131-154. Ebsco",
    "href": "/pdf/2000-Linguistic-Cultural-Cognitive-Capacities.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Kanzi and bonobos",
      "Chimpanzee studies"
    ],
    "summary": "This publication is part of the BHI research archive on lexigrams and symbolic communication, language comprehension. It is included because it documents a specific strand of ape language research connected to the bibliography: Linguistic, Cultural and Cognitive Capacities of Bonobos ( Pan paniscus). Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "2000-observational-word-learning-bonobos",
    "year": "2000",
    "title": "Observational Word Learning in Two Bonobos (Pan Paniscus): Ostensive and Non-Ostensive Contexts",
    "citation": "Lyn, H., & Savage-Rumbaugh, E. S. (2000). Observational Word Learning in Two Bonobos (Pan Paniscus): Ostensive and Non-Ostensive Contexts. Language & Communication, 20(3), 255-273. Doi",
    "href": "/pdf/2000-Observational-Word-Learning-Bonobos.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Kanzi and bonobos"
    ],
    "summary": "Word learning has been extensively studied in humans. Children seem to be able to map new words onto objects with only one exposure to"
  },
  {
    "id": "2000-review-cultural-origins-essr",
    "year": "2000",
    "title": "The Cultural Origins of Human Cognition (Book Review)",
    "citation": "Savage-Rumbaugh, E. S., & Fields, W. M. (2000). The Cultural Origins of Human Cognition (Book Review). American Anthropologist, 102(4), 925. Doi",
    "href": "/pdf/2000-Review-Cultural-Origins-ESSR.pdf",
    "topics": [
      "Tool use and material culture",
      "Cognition, selfhood, and consciousness",
      "Evolution, culture, and morality"
    ],
    "summary": "masello Review by: E. Sue Savage-Rumbaugh Source: American Anthropologist , Dec., 2000, Vol. 102, No."
  },
  {
    "id": "2002-bonobo-spatial-memory",
    "year": "2002",
    "title": "Bonobo (Pan paniscus) Spatial Memory and Communication in a 20-hectare Forest",
    "citation": "Menzel, C. R., Savage-Rumbaugh, E. S., & Menzel Jr, E. W. (2002). Bonobo (Pan paniscus) Spatial Memory and Communication in a 20-hectare Forest. International Journal of Primatology, 23(3), 601-619. Ebsco",
    "href": "/pdf/2002-Bonobo-Spatial-Memory.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Kanzi and bonobos",
      "Chimpanzee studies"
    ],
    "summary": "This publication is part of the BHI research archive on lexigrams and symbolic communication, language comprehension. It is included because it documents a specific strand of ape language research connected to the bibliography: Bonobo (Pan paniscus) Spatial Memory and Communication in a 20-hectare Forest. Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "2002-confrontatiions-support-discourse",
    "year": "2002",
    "title": "Confrontation and support in bonobo-human discourse",
    "citation": "Benson, J., Fries, P., Greaves, W., Iwamoto, K., Savage-Rumbaugh, S., & Taglialatela, J. (2002). Confrontation and support in bonobo-human discourse. Functions of Language, 9(1), 1-38. Ebsco",
    "href": "/pdf/2002-Confrontatiions-Support-Discourse.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Kanzi and bonobos",
      "Evolution, culture, and morality"
    ],
    "summary": "This publication is part of the BHI research archive on lexigrams and symbolic communication, language comprehension. It is included because it documents a specific strand of ape language research connected to the bibliography: Confrontation and support in bonobo-human discourse. Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "2003-vocal-production-paniscus",
    "year": "2003",
    "title": "Vocal Production by a Language-Competent Pan paniscus",
    "citation": "Taglialatela, J. P., Savage-Rumbaugh, S., & Baker, L. A. (2003). Vocal Production by a Language-Competent Pan paniscus. International Journal of Primatology, 24(1), 1-17. Ebsco",
    "href": "/pdf/2003-Vocal-Production-Paniscus.pdf",
    "topics": [
      "Language comprehension",
      "Kanzi and bonobos",
      "Gesture, vocalization, and multimodal language"
    ],
    "summary": "Jared P . Taglialatela,1,2 Sue Savage-Rumbaugh,1 and Lauren A. Baker1 Received September 18, 2001; revised Janaury 29, 2002; accepted March 11, 2002 Human spoken language and nonhuman primate vocalization systems have traditionally been regarded as qualitatively different from one another with re- spect to their semanticity and the way in which individuals acquire and utilize these signals."
  },
  {
    "id": "2004-mind-brain-apes",
    "year": "2004",
    "title": "Mind and brain in apes: a methodology for phonemic analysis of vocalizations of language competent bonobos",
    "citation": "Benson, J. D., Debashish, M., Greaves, W. S., Lukas, J., Savage-Rumbaugh, S., & Taglialatela, J. (2004). Mind and brain in apes: a methodology for phonemic analysis of vocalizations of language competent bonobos. Language Sciences, 26(6), 643-660. Ebsco",
    "href": "/pdf/2004-Mind-brain-Apes.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Kanzi and bonobos",
      "Gesture, vocalization, and multimodal language"
    ],
    "summary": "This publication is part of the BHI research archive on lexigrams and symbolic communication, language comprehension. It is included because it documents a specific strand of ape language research connected to the bibliography: Mind and brain in apes: a methodology for phonemic analysis of vocalizations of language competent bonobos. Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "2005-culture-prefigures-cognition",
    "year": "2005",
    "title": "Culture Prefigures Cognition in Pan/Homo Bonobos",
    "citation": "Savage-Rumbaugh, S., Fields, W. M., Segerdahl, P., & Rumbaugh, D. (2005). Culture Prefigures Cognition in Pan/Homo Bonobos. THEORIA. An International Journal for Theory, History and Foundations of Science, 20 (3), 311-328. Doi",
    "href": "/pdf/2005-Culture-Prefigures-Cognition.pdf",
    "topics": [
      "Language comprehension",
      "Kanzi and bonobos",
      "Tool use and material culture",
      "Cognition, selfhood, and consciousness"
    ],
    "summary": "This publication is part of the BHI research archive on language comprehension, kanzi and bonobos. It is included because it documents a specific strand of ape language research connected to the bibliography: Culture Prefigures Cognition in Pan/Homo Bonobos. Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "2006-rules-and-tools",
    "year": "2006",
    "title": "Rules and tools: Beyond anthropomorphism",
    "citation": "Savage-Rumbaugh, S., & Fields, W. M. (2006). Rules and tools: Beyond anthropomorphism. In N. Toth & K. Schick (Eds.),{\" \"} The Oldowan: Case Studies into the Earliest Stone Age (Vol. 1), Gosport, In. Stone Age Institute Press.",
    "href": "/pdf/2006-Rules-and-Tools.pdf",
    "topics": [
      "Kanzi and bonobos",
      "Chimpanzee studies",
      "Tool use and material culture"
    ],
    "summary": "This publication is part of the BHI research archive on kanzi and bonobos, chimpanzee studies. It is included because it documents a specific strand of ape language research connected to the bibliography: Rules and tools: Beyond anthropomorphism. Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "2006-development-representational-play",
    "year": "2006",
    "title": "The Development of Representational Play in Chimpanzees and Bonobos: Evolutionary Implications, Pretense, and the Role of Interspecies Communication",
    "citation": "Lyn, H., Greenfield, P., & Savage-Rumbaugh, S. (2006). The Development of Representational Play in Chimpanzees and Bonobos: Evolutionary Implications, Pretense, and the Role of Interspecies Communication. Cognitive Development, 21(3), 199-213. Ebsco",
    "href": "/pdf/2006-Development-Representational-Play.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Kanzi and bonobos",
      "Chimpanzee studies"
    ],
    "summary": "This publication is part of the BHI research archive on lexigrams and symbolic communication, language comprehension. It is included because it documents a specific strand of ape language research connected to the bibliography: The Development of Representational Play in Chimpanzees and Bonobos: Evolutionary Implications, Pretense, and the Role of Interspecies Communication. Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "2007-material-practices",
    "year": "2007",
    "title": "The material practices of ape language research",
    "citation": "Fields, W. M., Segerdahl, P., & Savage-Rumbaugh, S. (2007). The material practices of ape language research. In Jaan Valsiner & Alberto Rosa (Eds.), The Cambridge Handbook of Sociocultural Psychology. New York: Cambridge University Press.",
    "href": "/pdf/2007-Material-Practices.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Tool use and material culture",
      "Gesture, vocalization, and multimodal language"
    ],
    "summary": "William Mintz Fields, P ¨ ar Segerdahl, and Sue Savage-Rumbaugh This chapter is about a special population of non-human primates whose abilities and social competencies deserve the attention of cultural studies. Our contribution arises from a long-term investigation of language, culture, and tools in a society of bono- bos (Pan paniscus) having lived in Decatur, Georgia for the last 25 years. Their names are Kanzi (25 ), Panbanisha (19), Nyota (7 ), Nathan (4), Matata (36), Elikya, Maisha (9), and P-Suke (28 )."
  },
  {
    "id": "2008-precursors-of-morality",
    "year": "2008",
    "title": "Precursors of Morality in the Use of the Symbols 'Good' and 'Bad' in Two Bonobos (Pan Paniscus) and a Chimpanzee (Pan Troglodytes )",
    "citation": "Lyn, H., Franks, B., & Savage-Rumbaugh, E. S. (2008). Precursors of Morality in the Use of the Symbols 'Good' and 'Bad' in Two Bonobos (Pan Paniscus) and a Chimpanzee (Pan Troglodytes ). Language & Communication, 28(3), 213-224. Doi",
    "href": "/pdf/2008-Precursors-of-Morality.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Kanzi and bonobos",
      "Chimpanzee studies"
    ],
    "summary": "Morality is a concept that is based on value judgments of ‘‘right ” or ‘‘wrong ” and ‘‘good ” and ‘‘bad ”. Three language-competent apes (two bonobos and a chimpanzee) are shown to use"
  },
  {
    "id": "2009-empirical-kanzi",
    "year": "2009",
    "title": "Empirical Kanzi: The Ape Language Controversy Revisited",
    "citation": "Savage-Rumbaugh, S., Rumbaugh, D., & Fields, W. M. (2009). Empirical Kanzi: The Ape Language Controversy Revisited. Skeptic, 15(1), 25-33. Ebsco",
    "href": "/pdf/2009-Empirical-Kanzi.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Kanzi and bonobos",
      "Chimpanzee studies"
    ],
    "summary": "linguistic categories,** By age nine Kanzi was demonstrating comprehension of spoken English at"
  },
  {
    "id": "2008-protolanguage-ontology-phylogeny",
    "year": "2010",
    "title": "Protolanguage in Ontogeny and Phylogeny: Combining Deixis and Representation",
    "citation": "Greenfield, P. M., Lyn, H., & Savage-Rumbaugh, E. S. (2010). Protolanguage in Ontogeny and Phylogeny: Combining Deixis and Representation. In M. A. Arbib & D. Bickerton (Eds.), The Emergence of Protolanguage: Holophrasis vs. Compositionality {\" \"} (pp. 35-50). John Benjamins Publishing Company. Doi",
    "href": "/pdf/2008-Protolanguage-Ontology-Phylogeny.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Kanzi and bonobos",
      "Chimpanzee studies"
    ],
    "summary": "This publication is part of the BHI research archive on lexigrams and symbolic communication, language comprehension. It is included because it documents a specific strand of ape language research connected to the bibliography: Protolanguage in Ontogeny and Phylogeny: Combining Deixis and Representation. Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "2010-semiotic-combinations-pan",
    "year": "2010",
    "title": "Semiotic Combinations in Pan: A Comparison of Communication in a Chimpanzee and Two Bonobos",
    "citation": "Lyn, H., Greenfield, P. M., & Savage-Rumbaugh, E. S. (2010). Semiotic Combinations in Pan: A Comparison of Communication in a Chimpanzee and Two Bonobos. First Language, 31(3 [97]), 300-325. Doi",
    "href": "/pdf/2010-Semiotic-Combinations-Pan.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Kanzi and bonobos",
      "Chimpanzee studies"
    ],
    "summary": "Communicative combinations of two bonobos (Pan paniscus) and a chimpanzee (Pan troglodytes) are compared. All three apes utilized ordering strategies for combining symbols (lexigrams) or a lexigram with a gesture to express semantic relations such as agent of action or object of action. Combinatorial strategies used by all three apes revealed commonalities with child language, spoken and signed, at"
  },
  {
    "id": "2011-primates-do-declare",
    "year": "2011",
    "title": "Nonhuman Primates do Declare! A Comparison of Declarative Symbol and Gesture Use in Two Children, Two Bonobos, and A Chimpanzee",
    "citation": "Lyn, H., Greenfield, P. M., Savage-Rumbaugh, S., Gillespie-Lynch, K., & Hopkins, W. D. (2011). Nonhuman Primates do Declare! A Comparison of Declarative Symbol and Gesture Use in Two Children, Two Bonobos, and A Chimpanzee. Language Communication, 31(1), 63-74. Doi",
    "href": "/pdf/2011-Primates-do-Declare.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Kanzi and bonobos",
      "Chimpanzee studies"
    ],
    "summary": "While numerous publications have shown that apes can learn some aspects of human language, one frequently cited difference between humans and apes is"
  },
  {
    "id": "2011-evolution-rise-language",
    "year": "2011",
    "title": "The Evolution and the Rise of Human Language: Carry the Baby",
    "citation": "Savage-Rumbaugh, E. S., & Fields, W. M. (2011). The Evolution and the Rise of Human Language: Carry the Baby. In C. S. Henshilwood & F. D'Errico (Eds.), Homo Symbolicus: The Dawn of Language, Imagination and Spirituality {\" \"} (pp. 13-47). John Benjamins Publishing Company. French translation / Doi",
    "href": "/pdf/2011-Evolution-Rise-Language.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Tool use and material culture",
      "Cognition, selfhood, and consciousness"
    ],
    "summary": "13 E. Sue Savage-Rumbaugh & William M. Fields chapter 3 The origin of symbolically mediated behaviour: From antagonistic scenarios to a unified research strategy 49 Francesco d’Errico & Christopher S."
  },
  {
    "id": "2011-dialogue-ontogeny-phylogeny",
    "year": "2011",
    "title": "The role of dialogue in the ontogeny and phylogeny of early symbol combinations: A cross-species comparison of bonobo, chimpanzee, and human learners",
    "citation": "Gillespie-Lynch, K., Greenfield, P. M., Lyn, H., & Savage-Rumbaugh, S. (2011). The role of dialogue in the ontogeny and phylogeny of early symbol combinations: A cross-species comparison of bonobo, chimpanzee, and human learners. First Language, 31(4), 442-460. Ebsco",
    "href": "/pdf/2011-Dialogue-Ontogeny-Phylogeny.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Kanzi and bonobos",
      "Chimpanzee studies"
    ],
    "summary": "This publication is part of the BHI research archive on lexigrams and symbolic communication, language comprehension. It is included because it documents a specific strand of ape language research connected to the bibliography: The role of dialogue in the ontogeny and phylogeny of early symbol combinations: A cross-species comparison of bonobo, chimpanzee, and human learners. Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "2012-stone-tool-production",
    "year": "2012",
    "title": "Stone tool production and utilization by bonobo-chimpanzees (Pan paniscus)",
    "citation": "Roffman, I., Savage-Rumbaugh, S., Rubert-Pugh, E., Ronen, A., & Nevo, E. (2012). Stone tool production and utilization by bonobo-chimpanzees (Pan paniscus). Proceedings of the National Academy of Sciences, 109(36), 14500-14503. Ebsco",
    "href": "/pdf/2012-Stone-Tool-Production.pdf",
    "topics": [
      "Language comprehension",
      "Kanzi and bonobos",
      "Chimpanzee studies",
      "Tool use and material culture"
    ],
    "summary": "This publication is part of the BHI research archive on language comprehension, kanzi and bonobos. It is included because it documents a specific strand of ape language research connected to the bibliography: Stone tool production and utilization by bonobo-chimpanzees (Pan paniscus). Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "2013-cross-species-gesture",
    "year": "2013",
    "title": "A cross-species study of gesture and its role in symbolic development: implications for the gestural theory of language evolution",
    "citation": "Gillespie-Lynch, K., Greenfield, P. M., Feng, Y., Savage-Rumbaugh, E.S., & Lyn, H. (2013). A cross-species study of gesture and its role in symbolic development: implications for the gestural theory of language evolution. Frontiers in Psychology, 4, 160. Doi",
    "href": "/pdf/2013-Cross-Species-Gesture.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Kanzi and bonobos",
      "Chimpanzee studies"
    ],
    "summary": "This publication is part of the BHI research archive on lexigrams and symbolic communication, language comprehension. It is included because it documents a specific strand of ape language research connected to the bibliography: A cross-species study of gesture and its role in symbolic development: implications for the gestural theory of language evolution. Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "2013-human-uniqueness",
    "year": "2013",
    "title": "Human uniqueness–Constructions of ourselves and our sibling species: Pan troglodytes and Pan paniscus",
    "citation": "Savage-Rumbaugh, E. S., & Fields, W. M. (2013). Human uniqueness–Constructions of ourselves and our sibling species: Pan troglodytes and Pan paniscus. Quo Vadis, Behavioural Biology? Past, Present, and Future of an Evolving Science, 111 (380), 205-226.",
    "href": "/pdf/2013-Human-Uniqueness.pdf",
    "topics": [
      "Kanzi and bonobos",
      "Chimpanzee studies",
      "Evolution, culture, and morality"
    ],
    "summary": "This publication is part of the BHI research archive on kanzi and bonobos, chimpanzee studies. It is included because it documents a specific strand of ape language research connected to the bibliography: Human uniqueness–Constructions of ourselves and our sibling species: Pan troglodytes and Pan paniscus. Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "2014-gestural-symbolic-development",
    "year": "2014",
    "title": "Gestural and symbolic development among apes and humans: support for a multimodal theory of language evolution",
    "citation": "Gillespie-Lynch, K., Greenfield, P. M., Lyn, H., & Savage-Rumbaugh, S. (2014). Gestural and symbolic development among apes and humans: support for a multimodal theory of language evolution. Frontiers in Psychology, 5, 1228. Doi",
    "href": "/pdf/2014-Gestural-Symbolic-Development.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Kanzi and bonobos",
      "Chimpanzee studies"
    ],
    "summary": "Kristen Gillespie-Lynch1,2*, Patricia M. Greenﬁeld 2, Heidi Lyn 3 and Sue Savage-Rumbaugh4 1 Department of Psychology, College of Staten Island, City University of New Y ork, New Y ork, NY , USA 2 Department of Psychology, University of California, Los Angeles, Los Angeles, CA, USA 3 Department of Psychology, University of Southern Mississippi, Long Beach, MS, USA 4 President of Bonobo Hope, Des Moines, IA, USA Edited by: Christopher B. Sturdy, University of Alberta, Canada Reviewed by: Simone Pika, Max Planck Society, Germany Elena Nicoladis, University of Alberta, Canada *Correspondence: Kristen..."
  },
  {
    "id": "2014-language-learning-primates",
    "year": "2014",
    "title": "Language Learning in Non-human Primates",
    "citation": "Gillespie-Lynch, K., Savage-Rumbaugh, S. & Lyn, H. (2014). Language Learning in Non-human Primates In: P. J. Brooks & V. Kempe (Eds.).{\" \"} Encyclopedia of Language Development. Sage Press.",
    "href": "/pdf/2014-Language-Learning-Primates.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Kanzi and bonobos",
      "Chimpanzee studies"
    ],
    "summary": "This publication is part of the BHI research archive on lexigrams and symbolic communication, language comprehension. It is included because it documents a specific strand of ape language research connected to the bibliography: Language Learning in Non-human Primates. Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "2015-preparation-natural-tools",
    "year": "2015",
    "title": "Preparation and use of varied natural tools for extractive foraging by bonobos (Pan Paniscus)",
    "citation": "Roffman, I., Savage-Rumbaugh, S., Rubert-Pugh, E., Stadler, A., Ronen, A., & Nevo, E. (2015). Preparation and use of varied natural tools for extractive foraging by bonobos (Pan Paniscus). American Journal of Physical Anthropology, 158(1), 78-91. Doi",
    "href": "/pdf/2015-Preparation-Natural-Tools.pdf",
    "topics": [
      "Language comprehension",
      "Kanzi and bonobos",
      "Chimpanzee studies",
      "Tool use and material culture"
    ],
    "summary": "This publication is part of the BHI research archive on language comprehension, kanzi and bonobos. It is included because it documents a specific strand of ape language research connected to the bibliography: Preparation and use of varied natural tools for extractive foraging by bonobos (Pan Paniscus). Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "2016-evolution-gene-expression-poster",
    "year": "2016",
    "title": "The evolution of gene expression in the term placenta of{\" \"} Viviparous mammals",
    "citation": "Armstrong, D. L., McGowen, M. R., Weckle, A., Caravas, J., Agnew, D., Savage-Rumbaugh, S., Nevo, E., Kim, C. J., Wagner, G. P., Romero, R., & Wildman, D. (2016). The evolution of gene expression in the term placenta of{\" \"} Viviparous mammals. (Poster) Institute for Genomic Biology, Computing Genomes for Reproductive Health, University of Illinois, Urbana-Champaign.",
    "href": "/pdf/2016-Evolution-Gene-Expression-Poster.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Chimpanzee studies",
      "Evolution, culture, and morality"
    ],
    "summary": "This publication is part of the BHI research archive on lexigrams and symbolic communication, chimpanzee studies. It is included because it documents a specific strand of ape language research connected to the bibliography: The evolution of gene expression in the term placenta of{\" \"} Viviparous mammals. Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "2017-ind-diffs-language-competencies",
    "year": "2017",
    "title": "Individual differences in language competencies in apes resulting from unique rearing conditions imposed by different first epistemologies",
    "citation": "Savage-Rumbaugh, S., Segerdahl, P., & Fields, W. M. (2017). Individual differences in language competencies in apes resulting from unique rearing conditions imposed by different first epistemologies. In Laura L. Namy (Ed.), Symbol use and symbolic representation{\" \"} (pp. 200-220). Psychology Press.",
    "href": "/pdf/2017-Ind-Diffs-Language-Competencies.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Chimpanzee studies",
      "Tool use and material culture"
    ],
    "summary": "Sue Savage-Rumbaugh Georgia State University Par Segerdahl Uppsala Univeristy William M. Fields Georgia State University A GENE FOR LANGUAGE Many of those who have not been able to locate a specific neurological area of differentiation for language have turned to genetics in search of a language gene. Such searches are inevitably misguided as nothing as complicated as language can be coded in a single gene."
  },
  {
    "id": "2017-core-transcriptome-placenta",
    "year": "2017",
    "title": "The core transcriptome of mammalian placentas and the divergence of expression with placental shape",
    "citation": "Armstrong, D. L., McGowen, M. R., Weckle, A., Pantham, P., Caravas, J., Agnew, D., Benirschke, K., Savage-Rumbaugh, S., Nevo, E., Kim, C. J., Wagner, G. P., Romero, R., & Wildman, D. E. (2017). The core transcriptome of mammalian placentas and the divergence of expression with placental shape. Placenta, 57, 71-78. Doi",
    "href": "/pdf/2017-Core-Transcriptome-Placenta.pdf",
    "topics": [
      "Kanzi and bonobos",
      "Evolution, culture, and morality"
    ],
    "summary": "This publication is part of the BHI research archive on kanzi and bonobos, evolution, culture, and morality. It is included because it documents a specific strand of ape language research connected to the bibliography: The core transcriptome of mammalian placentas and the divergence of expression with placental shape. Open the source PDF for the full argument, evidence, methods, and citation context."
  },
  {
    "id": "2018-advent-of-selfhood",
    "year": "2018",
    "title": "Advent of selfhood",
    "citation": "Savage-Rumbaugh, S., & Roffman, I. (2018). Advent of selfhood. Journal of Veterinary Medicine and Animal Sciences",
    "href": "/pdf/2018-Advent-of-selfhood.pdf",
    "topics": [
      "Kanzi and bonobos",
      "Cognition, selfhood, and consciousness",
      "Evolution, culture, and morality"
    ],
    "summary": "1 Med Docs Publishers Received: Apr 10, 2018 Accepted: Jun 18, 2018 Published Online: Jun 25, 2018 Journal: Journal of Veterinary Medicine and Animal Sciences Publisher: Med Docs Publishers LLC Online edition: http://meddocsonline.org/ Copyright: © Savage-Rumbaugh S (2018). This Article is distributed under the terms of Creative Commons Attribution 4.0 International License *Corresponding Author(s): Sue Savage-Rumbaugh Great Ape Trust/Bonobo Hope Sanctuary, Des Moines, IA, USA Email: suerumbaugh@gmail.com Journal of Veterinary Medicine and Animal Sciences Open Access | Research Article Cite this article:..."
  },
  {
    "id": "2018-fully-conscious-ape",
    "year": "2018",
    "title": "The Fully Conscious Ape",
    "citation": "Savage-Rumbaugh, S., Roffman, I., Lingomo, S., & Pugh, E. (2018). The Fully Conscious Ape. International Journal of Comparative Psychology, 31, 1-62. Doi",
    "href": "/pdf/2018-Fully-Conscious-Ape.pdf",
    "topics": [
      "Language comprehension",
      "Kanzi and bonobos",
      "Cognition, selfhood, and consciousness"
    ],
    "summary": "Sue Savage-Rumbaugh1, Itai Roffman2, Sabatien Lingomo3, and Elizabeth Pugh4 1Missouri State University, U.S.A. 2Yezreel Valley College, Israel 3La Foret des Bonobos, Congo 4Geat Ape Trust of Iowa, U.S.A. The fact that language can both span time and yet create a reality of spoken space/time – when employed in a common way by a group of human beings – gives rise to the question of whether we are constructing language or language is constructing us."
  },
  {
    "id": "2019-pan-survival",
    "year": "2019",
    "title": "Pan Survival in the 21st Century: Chimpanzee Cultural Preservation, Rehabilitation, and Emancipation Manifesto",
    "citation": "Roffman, I., Mizrachi, Y., Chiarelli, B., Savage-Rumbaugh, S., Rubert-Pugh, E., Fontaine, L., Panchevre, M., Ronen, A., & Nevo, E. (2019). Pan Survival in the 21st Century: Chimpanzee Cultural Preservation, Rehabilitation, and Emancipation Manifesto. Human Evolution, 34(1/2), 1-19. Ebsco",
    "href": "/pdf/2019-Pan Survival.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Kanzi and bonobos",
      "Chimpanzee studies"
    ],
    "summary": ") and having struc- tural bilateral communication with syntax via pantomiming fulfill"
  },
  {
    "id": "2019-language-growth-hands-mouths",
    "year": "2019",
    "title": "What did language grow from? Ape hands, mouths, or both?",
    "citation": "Gillespie-Lynch, K. M., Savage-Rumbaugh, E. S., Lyn, H., & Greenfield, P. (2019). What did language grow from? Ape hands, mouths, or both? Frontiers in Neuroscience for Young Minds",
    "href": "/pdf/2019-Language-Growth-Hands-Mouths.pdf",
    "topics": [
      "Lexigrams and symbolic communication",
      "Language comprehension",
      "Kanzi and bonobos",
      "Chimpanzee studies"
    ],
    "summary": "Kristen Marie Gillespie-Lynch /one.tnum*, Emily Sue Savage-Rumbaugh /two.tnum, Heidi Lyn /three.tnumand Patricia M. Greenﬁeld /four.tnum /one.tnum Department of Psychology, College of Staten Island & The Graduate C enter, City University of New York, New York, NY, United States /two.tnum Independent Researcher, Springﬁeld, MO, United States /three.tnum Department of Psychology, University of South Alabama, Mobile, AL , United States /four.tnum Department of Psychology, University of California, Los Angele s, Los Angeles, CA, United States YOUNG REVIEWERS: ESTES HILLS ELEMENTARY AGE:..."
  }
];
